<template>
  <div class="d-flex fill-height w-full">
    <!-- <v-card flat class="d-flex flex-row w-full transparent"> -->
    <v-tabs
      v-model="activeTab"
      vertical
      background-color="transparent"
      show-arrows
      left
      style="width: 250px; min-width: 250px; border-right: 1px solid #e0e0e0"
    >
      <v-tab :ripple="false" v-for="tab in tabs" :key="tab.id" class="tabsClass w-full border-b">
        {{ tab.name }}
      </v-tab>
    </v-tabs>

    <div style="width: calc(100% - 250px)">
      <component :is="currentTabComponent" v-bind="$attrs" ref="activeComponent" />
    </div>
    <!-- </v-card> -->
  </div>
</template>

<script>
import Templates from './Templates.vue'
import Reimbursements from './Reimbursements.vue'
import SalaryLogs from './SalaryLogs.vue'

export default {
  name: 'SalaryTemplateConfig',
  components: {
    Templates,
    Reimbursements,
    SalaryLogs
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { id: 0, name: 'Salary Templates', component: 'Templates' },
        { id: 1, name: 'Reimbursements Templates', component: 'Reimbursements' },
        { id: 2, name: 'Salary Logs', component: 'SalaryLogs' }
      ]
    }
  },
  computed: {
    currentTabComponent() {
      return this.tabs[this.activeTab].component
    }
  },
  methods: {
    openCreateTemplate() {
      this.activeTab = 0
      this.$nextTick(() => {
        if (
          this.$refs.activeComponent &&
          typeof this.$refs.activeComponent.openCreateTemplate === 'function'
        ) {
          this.$refs.activeComponent.openCreateTemplate()
        }
      })
    }
  }
}
</script>

<style scoped>
.transparent {
  background-color: transparent !important;
}
.tabsClass {
  text-transform: capitalize !important;
  display: flex;
  align-self: flex-start;
  font-size: 14px !important;
  justify-content: flex-start;
  height: 40px !important;
  font-weight: 600;
}
</style>
